/**
 * @generated SignedSource<<c74a8a22886b7f6b2eee96de01adffe0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BrainSearchRelatedQuestionListFragment$data = {
  readonly brainSearchRelatedQuestions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly text: string;
      };
    }>;
    readonly totalCount: number;
  };
  readonly id: string;
  readonly " $fragmentType": "BrainSearchRelatedQuestionListFragment";
};
export type BrainSearchRelatedQuestionListFragment$key = {
  readonly " $data"?: BrainSearchRelatedQuestionListFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"BrainSearchRelatedQuestionListFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BrainSearchRelatedQuestionListFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 3
        }
      ],
      "concreteType": "BrainSearchRelatedQuestionNodeConnection",
      "kind": "LinkedField",
      "name": "brainSearchRelatedQuestions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BrainSearchRelatedQuestionNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "BrainSearchRelatedQuestion",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "text",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "brainSearchRelatedQuestions(first:3)"
    }
  ],
  "type": "BrainSearchMessage",
  "abstractKey": null
};
})();

(node as any).hash = "9a5f25cb2a045c37f74cbb5b9b820781";

export default node;
